<!-- Results Tab (only shows if screening is completed and results are stored) -->
<app-results *ngIf="hasResults; else startScreening" (clearResult)="clearResults()"></app-results>
<!-- Start Screening Tab (Shows if there are no results) -->
<ng-template #startScreening>
    <div class="section">
        <div>
            <h1 class="title">Start screening</h1>
            <div class="content">
                <div class="vertical-block">
                    <div class="c-column">
                        <!-- Start new -->
                        <div class="column column-start-screening">
                            <h1 class="column__title">Start a new screening</h1>
                            <p class="column__copy">If this is your first time using the screening tool*, or you want to start a new screening for one of your patients, click the button below.</p>
                            <p class="column__copy"><b><i>Please ensure you are aware of the variables required to complete the screening process, and  take a few minutes to <a (click)="openModal('screening-tool-landing-start-screening-user-guide-link-cta')">watch the user guide</a> before starting.</i></b></p>
                            <app-button text="Start screening" icon="assets/icons/icon-arrow-forward.svg" (btnClick)="start()"></app-button>
                            <p class="column__copy">*This tool is not a diagnostic test for EPI, and is not designed to provide any treatment recommendations for patients.</p>
                        </div>
                        <!-- Continue -->
                        <div class="column column-start-screening">
                            <h1 class="column__title">Continuing an existing screening</h1>
                            <p class="column__copy">If you are part-way through a screening, please enter your <b>progress-code</b> to continue from where you left off.</p>
                            <label for="">Progress code:</label>
                            <input type="text" class="custom-input" placeholder="Enter your progress code" [(ngModel)]="progressCode" (ngModelChange)="notifyProgressCodeChanged($event)">
                            <app-button text="Continue screening" [variation]="progressCode === '' || !questionIdList.includes(progressCode) ? 'button--disabled' : ''" icon="assets/icons/icon-arrow-forward.svg" (btnClick)="continue()" [disabled]="progressCode === ''"></app-button>
                        </div>
                    </div>
                </div>
                <!-- Video -->
                <div class="vertical-block video">
                    <div class="video__thumbnail" (click)="openModal('screening-tool-landing-start-screening-user-guide-button-cta')">
                        <button class="circle-button circle-button--lg">
                            <img src="assets/icons/icon-play.svg" alt="Play icon">
                        </button>
                    </div>
                    <h4 class="video__caption">User guide: How to use the Screen for EPI in CP tool</h4>
                    <div class="horizontal-block">
                        <img src="assets/icons/icon-clock.svg" alt="Time icon">
                        <p>3.5 minute watch</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Nav Component -->
    <app-bottom-navigation 
        backRoute="screening-tool-landing"
        backTab="introduction" 
        backText="Introducing the screening tool" 
        continueRoute="screening-tool-landing" 
        continueTab="feedback" 
        continueText="Feedback">
    </app-bottom-navigation>
    <!-- Brightcove Video Modal -->
    <app-modal *ngIf="videoModal" class="video-modal" (modalClose)="hideVideoModal()">
        <app-video-player analyticsTitle="User guide: How to use the Screen for EPI in CP tool" [video]="{ brightcoveAccountId: '1029485116001', brightcovePlayerId: 'default', videoId: '6322975218112'}"></app-video-player>
    </app-modal>
    <!-- HCP Modal -->
    <app-hcp *ngIf="hcpModal" (modalShouldClose)="handleModalClose()" (answerSubmit)="continueNavigation()"></app-hcp>
</ng-template>